import { createIcon } from '../createIcon';
import { ReactComponent as IconSortDown } from '../svg/sort-down.svg';

export default createIcon(IconSortDown);
